export const environment = {
  production: true,
  serviceWorkerEnabled: true,
  useLocalProxy: false,
  version: '{branch}.{pipeline}',
};
